/** Label for carousel / card "Project Materials" CTAs. */
export function projectMaterialsLabel(hasMaterials?: boolean): string {
  return hasMaterials === false ? 'Project Materials (Pending)' : 'Project Materials';
}

/** Label for the project detail "View Project Resources" CTA. */
export function projectResourcesLabel(hasMaterials?: boolean): string {
  return hasMaterials === false
    ? 'View Project Resources (Pending)'
    : 'View Project Resources';
}

/** True when the materials CTA should open the resources dialog. */
export function canOpenProjectMaterials(hasMaterials?: boolean): boolean {
  return hasMaterials !== false;
}
